module.exports = __webpack_public_path__ + "img/fsilogo-no-bg.7d38a07a.png";